import script from "./PlatformArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformArticle.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformArticle.vue?vue&type=style&index=0&id=5877b73a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5877b73a"]])

export default __exports__